/**
 * CVV input with card-type-aware validation
 */

import React from 'react';
import { TextField} from '@mui/material';
import { formatCvv } from '../services/formatters';
import { getExpectedCvvLength } from '../services/cardTypeDetector';

import { CardType } from '../types/CardData';

export interface CVVInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  cardType?: CardType;
}

export const CVVInput: React.FC<CVVInputProps> = ({
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
  cardType = 'unknown',
}) => {
 
  const expectedLength = getExpectedCvvLength(cardType);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value;
    const formatted = formatCvv(rawValue, expectedLength);
    onChange(formatted);
  };

  const handleBlur = () => {
  
    onBlur?.();
  };

  // Show error from parent (form submission) immediately, or show live validation only if touched
 const displayError = error;

  return (
    <div className="field-container align-items-center">
      <div className="label">
        <label className="p-2" data-testid="CVV" htmlFor="cvv">
          CVV
        </label>
        <span className="text-danger" data-testid="CVV-Astrict-icon">
          *
        </span>
      </div>
      <TextField
        id="cvv"
        className="textfield"
        fullWidth
        // label="CVV"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={!!displayError}
        helperText={displayError || ' '}
        disabled={disabled}
        autoComplete="cc-csc"
        inputMode="numeric"
        placeholder={expectedLength === 4 ? '1234' : '123'}
        required
        type="password"
        InputProps={{
        }}
        inputProps={{
          'aria-label': 'CVV security code',
          'aria-required': 'true',
          'aria-invalid': !!displayError,
          'aria-describedby': displayError ? 'cvv-error' : undefined,
          maxLength: expectedLength,
        }}
      />
    </div>
  );
};

export default CVVInput;
